import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import { params } from '../../config/params';
import { searchParams } from '../../config/searchParams';
import { urlConfig } from '../../config/baseUrl';
import InLinneLoading from '../../components/common/InlineLoading';
import Pagination from '../../components/Pagination';
import { toast } from '../../services/toastService';
import Loading from '../../components/common/Loading';
import { Link } from 'react-router-dom';
import DeleteConfirmation from '../../components/DeleteConfirmation';
import { bannerService } from '../../services/bannerService';

const Banners = () => {
  const { t,lang } = useContext(LocaleContext);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
        setLoading(true);
        getAllAsync();
      }, []);
    
      const getAllAsync = async () => {
        try {
          var data = await bannerService.getAllAsync(params);
          setData(data);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      const getAllSearchAsync = async (signal) => {
        try {
          var data = await bannerService.getAllSearchAsync(searchParams, signal);
          setData(data);
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      };
      // 🟢 Search effect with debounce & cancel
      useEffect(() => {
        if (search.trim().length < 2) {
          params.pageNumber = 1;
          getAllAsync(); // reset to default if search is cleared
          return;
        }
    
        const controller = new AbortController(); // cancel token
        const delay = setTimeout(() => {
          searchParams.search = search.trim(); // update global params
          searchParams.pageNumber = 1; // reset page to 1 on search
          getAllSearchAsync(controller.signal);
        }, 400); // debounce time
    
        return () => {
          controller.abort(); // cancel previous request
          clearTimeout(delay); // clear debounce
        };
      }, [search]);
      const onPageChange = async (pageNumber) => {
        setLoading(true);
        if (!search) {
          params.pageNumber = pageNumber;
          getAllAsync();
          return;
        }
        searchParams.pageNumber = pageNumber;
        await getAllSearchAsync();
      };
      const handleDelete=async ()=>{
        try {
          if(!deleteId)
          {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            return;
          }
          setLoading(true);
          var response = await bannerService.deleteAsync(deleteId);
          console.log(response);
          if (!response.isSuccess) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(response);
            return;
          }
          toast.success(t("recordDeletedSuccessfully"));
          getAllAsync();
        } catch (error) {
          console.log(error)
        }
        finally{
          setLoading(false);
        }
      }
  return (
    <>
      {loading && <Loading />}
      <section className="section-categories">
        <div className="default-heading">{t("banners")}</div>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("bannerManagement")}</strong>
              <p>{t("viewAndManageAllBannersInTheSystem")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-file-excel"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-print"></i>
                  </div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                  <div className="grid-btn">
                    <Link to="/banner-form">
                      <button className="btn-default my-bg-secondary">
                        <i className="fas fa-plus"></i> {t("addNewBanner")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allBanners")}</b>
                <div className="dropdown d-none">
                  <i
                    className="fas fa-filter cursor-pointer"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <span></span>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("status")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("revenues")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("city")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("date")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <input type="checkbox" />
                      </th>
                      <th>{t("image")}</th>
                      <th>{t("title")}</th>
                      <th>{t("subTitle")}</th>
                      <th>{t("noOfTrips")}</th>
                      <th>{t("date")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td className="flex-center">
                          <div className="grid-image">
                            <img
                              src={`${urlConfig.imageBaseUrl}/${item.imagePath}`}
                              alt="Banner"
                            />
                          </div>
                        </td>
                        <td>{item.title[lang]}</td>
                        <td>{item.subTitle[lang]}</td>
                        <td>{item.noOfTrips}</td>
                        <td>{item.createdAt?.toDate()}</td>
                        <td>
                          <i
                            class="fas fa-ellipsis-vertical"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ></i>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href={`/banner-form/${item.id}`}
                              >
                                <i className="fas fa-edit"></i> {t("edit")}
                              </a>
                            </li>
                             <li>
                              <a
                                className="dropdown-item"
                                href={`/banner-details/${item.id}`}
                              >
                                <i className="fas fa-eye"></i> {t("view")}
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDeleteId(item.id);
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#my-modal"
                              >
                                <i className="fas fa-trash-alt text-danger"></i>{" "}
                                {t("delete")}
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                    {data?.items?.length === 0 && (
                      <tr>
                        <td colSpan="100%" className="text-center py-3">
                          {t("noResultsFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              {data && (
                <Pagination
                  t={t}
                  pageNumber={data.pageNumber}
                  totalPages={data.totalPages}
                  hasNextPage={data.hasNextPage}
                  hasPreviousPage={data.hasPreviousPage}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        </section>
      </section>
      <DeleteConfirmation t={t} handleDelete={handleDelete} />
    </>
  );
};

export default Banners